var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-status"},[_c('i',{staticClass:"f-icon ma-r fs-super lh-1em",domProps:{"innerHTML":_vm._s(_vm.currentStatus.icon)}}),_c('div',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.currentStatus.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }